import { INVOICE_TYPE_CLIENT, InvoiceBasicResource, InvoiceDto } from '@sr/dto';
import { HeaderText } from 'shared/ui/header-text';
import { formatDate } from 'utils/date-format-helpers';

export const InvoiceTitle = ({ invoice, basics }: { invoice: InvoiceDto, basics?: Pick<InvoiceBasicResource, 'startDate'> | null }) => {
  if (!invoice) return null;

  const companyName = invoice.type === INVOICE_TYPE_CLIENT
    ? invoice.buyerCompany.name
    : invoice.sellerCompany.name;
  const startDate = basics?.startDate ?? invoice.startDate;

  return invoice.type === INVOICE_TYPE_CLIENT
    ?
    <HeaderText>
      Исходящий счёт №<HeaderText.Stressed>{invoice.invoiceNumber}</HeaderText.Stressed>
      <> для компании <HeaderText.Stressed>{companyName}</HeaderText.Stressed></>
    </HeaderText>
    :
    <HeaderText>
      Входящий счёт №<HeaderText.Stressed>{invoice.invoiceNumber}</HeaderText.Stressed>
      <> от <HeaderText.Stressed>{formatDate(startDate)}</HeaderText.Stressed></>
      <> от компании <HeaderText.Stressed>{companyName}</HeaderText.Stressed></>
    </HeaderText>;
};
